var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4742 15.0002C16.4742 16.0867 15.6065 16.9674 14.5361 16.9674C13.4657 16.9674 12.5979 16.0867 12.5979 15.0002C12.5979 13.9137 13.4657 13.033 14.5361 13.033V0.246094C6.50803 0.246094 0 6.85173 0 15.0002C0 23.1487 6.50803 29.7543 14.5361 29.7543C22.5641 29.7543 29.0722 23.1487 29.0722 15.0002H16.4742Z",
    fill: "#131631"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5361 0.246094H29.0722V15.0002C29.0722 6.85173 22.5641 0.246094 14.5361 0.246094Z",
    fill: "#9CCFF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5361 0.246094V13.033C15.6065 13.033 16.4742 13.9137 16.4742 15.0002H29.0722C29.0722 6.85173 22.5641 0.246094 14.5361 0.246094Z",
    fill: "#00B4FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAvatar);
export default __webpack_public_path__ + "static/media/logo-avatar.4af424d6.svg";
export { ForwardRef as ReactComponent };